import { Outlet, RouteObject } from 'react-router-dom';

import { FullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader';

export const licensesRoutes: RouteObject = {
  path: '/license-management',
  hydrateFallbackElement: <FullscreenLoader />,
  Component: () => <Outlet />,
  handle: {
    crumb: {
      label: 'license-management',
      localized: true,
    },
    entity: 'License',
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { LicensesTableRoute } = await import('./licenses-table');
        return { Component: LicensesTableRoute };
      },
    },
  ],
};
